<!--
 * @Author: qinmengyuan
 * @Date: 2024-06-21 11:03:07
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-06-26 17:30:10
 * @FilePath: \onetab\src\components\SubscriptionModal.vue
-->
<template>
  <div class="mask" @click.self="handleClose">
    <Transition name="modal-fade">
      <div class="modal" v-if="isShow" v-loading="!Object.keys(versionList).length">
        <div class="header">
          <RaIcon icon="Close" @click="handleClose" />
        </div>
        <div class="content">
          <div class="desc">
            <div class="title">订阅专业版</div>
            <div class="year-meter">
              <div class="text">按年计费（节省20%）</div>
              <RaSwitch v-model="open"></RaSwitch>
            </div>
          </div>
          <div class="version-category">
            <div class="card" v-for="(item, index) in curList" :key="index">
              <div
                class="filter-decorate"
                :style="{ background: item.attribute.filterColor }"
              ></div>
              <div class="title">
                <div class="icon" :style="{ background: item.attribute.iconColor }">
                  <i class="iconfont icon-onetabVector"></i>
                </div>
                {{ item.type_name }}
              </div>
              <div class="price-mon">
                <span>￥</span><span class="text">{{ item.price }}</span
                ><span>/{{ `${open ? '年' : '月'}` }}</span>
              </div>
              <div class="price-year" :style="{ background: item.attribute.priceColor }" v-if="!open">
                <span>￥</span><span>{{ versionList.year[index].price }}</span
                ><span>/年</span>
              </div>
              <div class="section">
                <div class="item" v-for="(sec, num) in item.membership_benefits" :key="num">
                  <RaIcon :class="`check-${index}`" icon="Check" /><span>{{
                    sec
                  }}</span>
                </div>
              </div>
              <div
                class="btn"
                @click="handleBuy(item)"
                :style="{
                  background:
                    index === 0
                      ? 'linear-gradient(120deg, rgba(255, 255, 255, 0.20) 29.61%,'
                      : item.attribute.btnColor,
                  border:
                    index === 0 ? '1px solid rgba(245, 173, 29, 0.80)' : 'none',
                  color: index === 0 ? item.attribute.btnColor : '#fff',
                }"
              >
                购买
              </div>
              <div class="recommend" v-if="index > 0"><img :src="recommend" width="50" height="30"></div>
            </div>
          </div>
          <div class="user-notice">我已阅读并同意《会员订阅服务条款》</div>
        </div>
      </div>
    </Transition>
  </div>
  <OrderInfo v-if="orderInfoShow" :orderInfo="orderInfo" @handleClose="orderInfoShow = false" />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, reactive, computed } from 'vue';
import { RaIcon } from '@rafter/icon';
import { RaSwitch } from '@rafter/pc';
import OrderInfo from './OrderInfo.vue';
import { getVipTypes } from '@/api/baseApi';
import recommend from '../assets/recommend.png';
import { vipBuy } from '@/api/userApi';
import { RaMessage } from '@rafter/pc';

const emits = defineEmits(['handleClose']);
const orderInfoShow = ref(false);
const versionList = reactive({});
const isShow = ref(false);
const open = ref(false);
const orderInfo = ref(null);
const handleClose = () => {
  isShow.value = false;
  setTimeout(() => {
    emits('handleClose');
  }, 150);
};
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};

const curList = computed(()=>{
  return versionList[`${open.value ? 'year' : 'month'}`];
});

onMounted(() => {
  isShow.value = true;
  console.log('-----settingModal----');
  document.addEventListener('keydown', handleKeyDown);
  getVipTypes()
  .then(res => {
    for(let key in res.data.data){
      if(key === '年卡'){
        versionList['year'] = res.data.data[key];
      }else if(key === '月卡'){
        versionList['month'] = res.data.data[key];
      }
    }
  })
  .catch((e)=>{

  });
});
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

const handleBuy = (item) => {
  vipBuy({vip_id:item.id})
  .then(res=>{
    if(res.data.code === 200){
      orderInfo.value = res.data.data;
      console.log(orderInfo.value,'666');
      orderInfoShow.value = true;
    }else{
      RaMessage.error('请求服务失败，请重试');
    }
  })
  .catch((e=>{
    RaMessage.error('请求服务失败，请重试');
  }));
}
</script>
<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    display: flex;
    width: 66.666vw;
    height: 81.967vh;
    max-width: 1280px;
    max-height: 800px;
    border-radius: $base-border-radiuse-24;
    user-select: none;
    position: absolute;
    z-index: 1;
    overflow: hidden;
    background: url('../background/image_70.png') no-repeat center / cover;
    padding: 0 1.25vw;
    flex-direction: column;
    align-items: center;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: $base-border-radiuse-24;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: $base-bg-filter-40;
      z-index: -1;
    }
    .header {
      min-height: 40px;
      // height: 5.791vh;
      display: flex;
      align-items: center;
      width: -webkit-fill-available;
      flex-flow: row-reverse;
      i {
        border-radius: 50%;
        &:hover {
          background: #f56c6c !important;
          color: white !important;
        }
      }
    }
    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2.604vh;

      .desc {
        display: flex;
        flex-direction: column;
        gap: 0.827vh;
        align-items: center;
        .title {
          color: var(--Text-on-surface-primary, #181b22);
          text-align: center;
          /* web/cn/heading/heading-05 */
          font-family: 'PingFang SC';
          font-size: 1.25vw;
          font-style: normal;
          font-weight: 500;
          line-height: 150%; /* 36px */
          letter-spacing: 0.5px;
        }
        .year-meter {
          align-items: center;
          display: flex;
          gap: 0.625vw;
          .text {
            color: var(--Text-on-surface-secondary, #424751);
            text-align: center;
            font-family: 'PingFang SC';
            font-size: 0.833vw;
            font-style: normal;
            font-weight: 500;
            line-height: 150%; /* 24px */
            letter-spacing: 0.5px;
          }
          ::v-deep(.ra-switch--default.is-checked .ra-switch__core) {
            background: #7e6cf5;
          }
        }
      }
      .version-category {
        flex: 1;
        display: flex;
        gap: 2.083vw;
        .card {
          border-radius: 20px;
          background: var(--white-90, rgba(255, 255, 255, 0.9));
          width: 15.625vw;
          height: 57.911vh;
          padding: 2.895vh 0.729vw;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          // overflow: hidden;
          .filter-decorate {
            width: 18.229vw;
            height: var(--button-list-field-medium, 3.309vh);
            flex-shrink: 0;
            background: rgba(255, 209, 118, 0.5);
            filter: blur(25px);
            position: absolute;
            top: -1.654vh;
          }
          .title {
            color: var(--Text-on-surface-primary, #181b22);
            text-align: center;
            font-family: 'PingFang SC';
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 26px; /* 144.444% */
            display: flex;
            align-items: center;
            gap: 0.625vw;
            .icon {
              display: flex;
              width: var(--button-list-field-small, 24px);
              height: var(--button-list-field-small, 24px);
              padding: 1.5px 0.75px 0px 0px;
              justify-content: center;
              align-items: center;
              flex-shrink: 0;
              border-radius: 24px;
              .iconfont {
                color: white;
              }
            }
          }
          .price-mon {
            color: var(--Text-on-surface-primary, #181b22);
            font-family: 'PingFang SC';
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px; /* 133.333% */
            margin: 1.034vh 0;
            .text {
              color: var(--Text-on-surface-primary, #181b22);
              text-align: center;
              font-family: 'MiSans VF';
              font-size: 40px;
              font-style: normal;
              font-weight: 450;
              line-height: 150%; /* 60px */
              letter-spacing: -1px;
            }
          }
          .price-year {
            border-radius: 40px;
            background: #fef5e5;
            display: flex;
            height: var(--button-list-field-medium, 32px);
            padding: 8px var(--spacing-10, 20px);
            justify-content: center;
            align-items: center;
            gap: 0.416vw;
            color: var(--Text-on-surface-primary, #181b22);
            font-family: 'PingFang SC';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 157.143% */
            box-sizing: border-box;
            margin-bottom: 4.136vh;
          }
          .section {
            display: flex;
            flex-direction: column;
            gap: 0.416vw;
            flex: 1;
            overflow: auto;
            .item {
              display: flex;
              align-items: center;
              gap: 0.416vw;
              color: var(--Text-on-surface-primary, #181b22);
              font-family: 'PingFang SC';
              font-size: 12px;
              line-height: 22px;
              // font-size: 1.344vh;
              // line-height: 2.418vh; /* 184.615% */
              font-style: normal;
              font-weight: 400;
              .check-0 {
                ::v-deep(.svg-icon) {
                  color: #f5ab18;
                }
              }
              .check-1 {
                ::v-deep(.svg-icon) {
                  color: #4785ff;
                }
              }
              .check-2 {
                ::v-deep(.svg-icon) {
                  color: #7070ff;
                }
              }
            }
          }
          .btn {
            display: flex;
            width: 10.416vw;
            height: var(--button-list-field-medium, 3.309vh);
            padding: 0px var(--spacing-12, 24px) 0px 22px;
            justify-content: center;
            align-items: center;
            gap: 6px;
            flex-shrink: 0;
            box-sizing: border-box;
            /* web/cn/label/label-03 */
            font-family: 'PingFang SC';
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 153.846% */
            letter-spacing: 0.4px;
            border-radius: 8px;
            color: #fff;
            cursor: pointer;
          }
          .recommend {
            position: absolute;
            top: -12px;
            right: -10px;
          }
        }
      }
    }
    .user-notice {
      color: #7c7ca3;
      text-align: center;
      cursor: pointer;
      /* web/cn/helper/helper-02 */
      font-family: 'PingFang SC';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 18px */
      letter-spacing: 0.4px;
      margin-bottom: 12px;
    }
  }
}
</style>
